var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-10 py-md-13 py-lg-16"},[_c('TitleWidget',[_vm._v(_vm._s(_vm.title))]),_c('v-sheet',{staticClass:"mt-4 mt-md-6 mx-auto",attrs:{"color":"transparent","max-width":"500"}},[_c('ContactForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }